import React, { Component } from 'react'
import { connect } from "react-redux";
import{
  isFetchingCircle,
  getCircleWithId
} from "../../store/circles/selectors";
import {fetchCircle} from '../../store/circles/operations';

class CircleDecorator extends Component {
    componentDidMount(){         
        this.props.fetchCircle(this.props.circleId);         
    }

    render() {
        let children = this.props.children;
        if(this.props.circle_details){
            children = React.Children.map(this.props.children, (child, index) => {
                return React.cloneElement(child, {circle: this.props.circle_details});
            });
        }
        return (
            <>
            {children}
            {/* {
                !this.props.loading && this.props.circle_details &&
                children            
            }
            {
                this.props.showLoader && this.props.loading && !this.props.circle_details && <LoadingIndicator />
            } */}
            </>
        )
    }
}

const mapStateToProps = (state, own_props) => ({
    locale: state.i18n.locale,
    loading: isFetchingCircle(state, own_props.circleId),
    circle_details: getCircleWithId(state, own_props.circleId)   
});
const mapDispatchToProps = dispatch => ({   
    fetchCircle: (circleId) => dispatch(fetchCircle(circleId)),
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CircleDecorator);
  